/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Gateway Swagger API
 * OpenAPI spec version: 1.2
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  DtoLogout,
  HandlerTokenExchangeRequest,
  HandlerTokenExchangeResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자 로그아웃 처리. Refresh Token을 삭제하고 Access Token을 블랙리스트에 추가합니다
 * @summary 로그아웃
 */
export const postApiV6Logout = (
  dtoLogout: MaybeRef<DtoLogout>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dtoLogout = unref(dtoLogout);

  return customAxiosInstance<string>(
    {
      url: `/api/v6/logout`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dtoLogout,
      signal,
    },
    options,
  );
};

export const getPostApiV6LogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV6Logout>>,
    TError,
    { data: BodyType<DtoLogout> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV6Logout>>,
  TError,
  { data: BodyType<DtoLogout> },
  TContext
> => {
  const mutationKey = ['postApiV6Logout'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV6Logout>>,
    { data: BodyType<DtoLogout> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV6Logout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV6LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV6Logout>>
>;
export type PostApiV6LogoutMutationBody = BodyType<DtoLogout>;
export type PostApiV6LogoutMutationError = ErrorType<unknown>;

/**
 * @summary 로그아웃
 */
export const usePostApiV6Logout = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV6Logout>>,
      TError,
      { data: BodyType<DtoLogout> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiV6Logout>>,
  TError,
  { data: BodyType<DtoLogout> },
  TContext
> => {
  const mutationOptions = getPostApiV6LogoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Validate external integration token and exchange it for internal access, refresh, and session tokens
 * @summary Exchange external token for internal tokens
 */
export const postTokenExchange = (
  handlerTokenExchangeRequest: MaybeRef<HandlerTokenExchangeRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  handlerTokenExchangeRequest = unref(handlerTokenExchangeRequest);

  return customAxiosInstance<HandlerTokenExchangeResponse>(
    {
      url: `/token-exchange`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: handlerTokenExchangeRequest,
      signal,
    },
    options,
  );
};

export const getPostTokenExchangeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTokenExchange>>,
    TError,
    { data: BodyType<HandlerTokenExchangeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTokenExchange>>,
  TError,
  { data: BodyType<HandlerTokenExchangeRequest> },
  TContext
> => {
  const mutationKey = ['postTokenExchange'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTokenExchange>>,
    { data: BodyType<HandlerTokenExchangeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postTokenExchange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTokenExchangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTokenExchange>>
>;
export type PostTokenExchangeMutationBody = BodyType<HandlerTokenExchangeRequest>;
export type PostTokenExchangeMutationError = ErrorType<unknown>;

/**
 * @summary Exchange external token for internal tokens
 */
export const usePostTokenExchange = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTokenExchange>>,
      TError,
      { data: BodyType<HandlerTokenExchangeRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postTokenExchange>>,
  TError,
  { data: BodyType<HandlerTokenExchangeRequest> },
  TContext
> => {
  const mutationOptions = getPostTokenExchangeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
